import { mutator } from 'satcheljs';
import { trackCanvasBounds } from '../actions';
import getStore from '../store';

mutator(trackCanvasBounds, ({ top, left, bottom, right, width, height }) => {
    const { canvasBounds } = getStore();
    canvasBounds.top = top;
    canvasBounds.left = left;
    canvasBounds.bottom = bottom;
    canvasBounds.right = right;
    canvasBounds.width = width;
    canvasBounds.height = height;
});
